"use client";

import { useEffect, useState } from "react";
import { readConsent } from "./storage";
import {
	CONSENT_EVENT,
	type ConsentCategory,
	type ConsentRecord,
} from "./types";

export function useConsent(): {
	record: ConsentRecord | null;
	hydrated: boolean;
} {
	const [record, setRecord] = useState<ConsentRecord | null>(null);
	const [hydrated, setHydrated] = useState(false);

	useEffect(() => {
		setRecord(readConsent());
		setHydrated(true);

		const onChange = (e: Event) => {
			const detail = (e as CustomEvent<ConsentRecord | null>).detail;
			setRecord(detail ?? readConsent());
		};
		const onStorage = () => {
			setRecord(readConsent());
		};
		window.addEventListener(CONSENT_EVENT, onChange);
		window.addEventListener("storage", onStorage);
		return () => {
			window.removeEventListener(CONSENT_EVENT, onChange);
			window.removeEventListener("storage", onStorage);
		};
	}, []);

	return { record, hydrated };
}

export function useHasConsent(category: ConsentCategory): boolean {
	const { record } = useConsent();
	if (!record) return category === "necessary";
	return record.choices[category] === true;
}
